import {Switch, SwitchProps, Tooltip} from 'platform/components';
import {HStack, Icon} from 'platform/foundation';

import i18n from '@dms/i18n';

interface SourcingTableRealTimeSwitchProps {
  value: SwitchProps['value'];
  onChange: SwitchProps['onChange'];
  tooltip: string;
}

export function SourcingTableRealTimeSwitch(props: SourcingTableRealTimeSwitchProps) {
  return (
    <HStack spacing={1} align="center" data-testid="sourcing-real-time-switch">
      <Switch
        label={i18n.t('entity.sourcingTable.labels.realTime')}
        value={props.value}
        onChange={props.onChange}
      />
      <Tooltip label={props.tooltip}>
        <Icon
          value="action/info_outline"
          size={4}
          color="palettes.neutral.60.100"
          data-testid="sourcing-real-time-info-icon"
        />
      </Tooltip>
    </HStack>
  );
}
